import React, { useState, useEffect, useRef, useMemo } from 'react';
import axios from 'axios';
import { Link, RouteComponentProps, useHistory } from 'react-router-dom';
import { Button, Row, Col, FormGroup, Label } from 'reactstrap';
import { Translate, translate, ValidatedField, ValidatedForm } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { styled, createTheme, responsiveFontSizes, ThemeProvider } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import Dialog from '@material-ui/core/Dialog';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import { getEntityByIcAndBankId, updateEntity as updateCustomer } from 'app/entities/customer/customer.reducer';
import { getFeeListByBankId, getFeeListByBankIdAndCommodityType } from 'app/entities/comex-bank-fee/comex-bank-fee.reducer';
import { resolveLumpSumFeeAmount, isCommissionModeForBank, resolveCurrencyIdForFiltering } from 'app/shared/util/quotation-utils';
import { getCommoditiesByBankId } from 'app/entities/commodity/commodity.reducer';
import { getAllEntities as getCurrencies } from 'app/entities/currency-index/currency-index.reducer';
import { getAllEntities as getCurrencyRates } from 'app/entities/currency-rates/currency-rates.reducer';
// Replaced getEntity with getAllEntities because the first queries PAGINATED QUERIES, i.e. 20 BRANCHES
// import { getEntities as getBranches,getEntity as getBranch } from 'app/entities/branch/branch.reducer';
import { getEntity as getBranch } from 'app/entities/branch/branch.reducer';
import { getEntityByBranchId as getBankByBranchId } from 'app/entities/bank/bank.reducer';
import {
  getEntity,
  updateEntity,
  createEntity,
  reset,
  calculateQuotation,
  selectCalculationResult,
  selectCalculationLoading,
  resetCalculation,
} from './quotation.reducer';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { Storage } from 'react-jhipster';

import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { getAccount } from 'app/shared/reducers/authentication';
import {
  createEntity as createCustomer,
  getAllEntities as getCustomers,
  verifyExistingCustomerPhoneNumber,
} from '../customer/customer.reducer';
import { ICustomer, ICustomerQueryParam } from 'app/shared/model/customer.model';
import { IComexBankFee } from 'app/shared/model/comex-bank-fee.model';
import { ICommodity } from 'app/shared/model/commodity.model';
import 'react-phone-input-2/lib/style.css';
import PhoneInput from 'react-phone-input-2';
import { countryList } from 'app/entities/bank/country';
import './quotation-update.css';
import { getEntity as getComexSetting } from 'app/entities/comex-settings/comex-settings.reducer';

import moment from 'moment/moment';
import { getVerifyExistingEmailUser } from 'app/modules/administration/user-management/user-management.reducer';
import { IQuotationType } from 'app/shared/model/quotation.model';

import { IIban } from 'app/shared/model/iban.model';
import { createEntity as createIban, getEntityByQuotationId, updateEntity as updateIban } from 'app/entities/quotation/iban-reducer';
import { setQuotationType as setQuotationTypeReducer } from 'app/entities/quotation/quotation-type.reducer';

import LocalizationProvider from '@mui/lab/LocalizationProvider';
import { ar, enUS } from 'date-fns/locale';
import MobileDatePicker from '@mui/lab/MobileDatePicker';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import EventIcon from '@mui/icons-material/Event';
import { isBoubyanBank } from 'app/shared/util/quotation-utils';
export const QuotationUpdate = (props: RouteComponentProps<{ id: string }>) => {
  const historyBack = useHistory();
  const dispatch = useAppDispatch();
  const user = useAppSelector(state => state.authentication.account);
  const [isNew] = useState(!props.match.params || !props.match.params.id);
  const commodities = useAppSelector(state => state.commodity.entities);
  const quotationEntity = useAppSelector(state => state.quotation.entity);
  const quotationNo = useAppSelector(state => state.quotation.entity);
  const branchEntity = useAppSelector(state => state.branch.entity);

  const verifyEmailUser = useAppSelector(state => state.userManagement.verifyExistingEmailUser);
  const bankEntity = useAppSelector(state => state.bank.entity);
  const loading = useAppSelector(state => state.quotation.loading);
  const updating = useAppSelector(state => state.quotation.updating);
  const updateSuccess = useAppSelector(state => state.quotation.updateSuccess);
  const currencyRateList = useAppSelector(state => state.currencyRates.entities);
  const currencyIndexList = useAppSelector(state => state.currencyIndex.entities);
  const bankFeeList = useAppSelector(state => state.comexBankFee.entities);
  const account = useAppSelector(state => state.authentication.account);
  const customers = useAppSelector(state => state.customer.entities);
  const [itemDescription, setItemDescription] = useState('');
  const [itemDescriptionInArabic, setItemDescriptionInArabic] = useState('');
  const [itemPrice, setItemPrice] = useState(0);
  const [itemName, setItemName] = useState('');
  const [itemQuantity, setItemQuantity] = useState(0);
  const [itemQuantityUnit, setItemQuantityUnit] = useState('');
  const [amountV, setAmount] = useState(0);
  const [debouncedAmountV, setDebouncedAmountV] = useState(0);

  const [amountDisplayed, setAmountDisplayed] = useState('');
  const [currencyName, setCurrencyName] = useState('');
  const [displayCurrencyName, setDisplayCurrencyName] = useState('');
  const [isDefaultCurrency, setIsDefaultCurrency] = useState(false);
  const [cusIc, setCusIc] = useState('');
  const [cusIdSearch, setCusIdSearch] = useState('');
  const [cusName, setCusName] = useState('');
  const [cusNameAr, setCusNameAr] = useState('');
  const [cusNationality, setNationality] = useState('');
  const [cusNationalityArabic, setNationalityArabic] = useState('');
  const [phone, setPhone] = useState('');
  const [cusEmail, setCusEmail] = useState('');
  const [newEditCus, setNewEditCus] = useState(false);
  const [oldEditCusId, setOldEditCusId] = useState(0);
  const [bankIdData, setBankIdData] = useState(null);
  const [isComexSettingStatus, setIsComexSettingStatus] = useState(null);
  const formatTwoDigits = digit => ('0' + digit).slice(-2);
  const tempDate = new Date();
  // const today_date = `${formatTwoDigits(tempDate.getDate())}/${formatTwoDigits(tempDate.getMonth() + 1)}/${tempDate.getFullYear()}`;
  const today_date = `${tempDate.getFullYear()}/${formatTwoDigits(tempDate.getMonth() + 1)}/${formatTwoDigits(tempDate.getDate())}`;

  // Get the current time components
  const hours = formatTwoDigits(tempDate.getHours());
  const minutes = formatTwoDigits(tempDate.getMinutes());
  const seconds = formatTwoDigits(tempDate.getSeconds());

  const date = `${tempDate.getFullYear()}/${formatTwoDigits(tempDate.getMonth() + 1)}/${formatTwoDigits(tempDate.getDate())}`;
  // Concatenate the date and time components together
  const today_date_with_time = `${today_date} ${hours}:${minutes}:${seconds}`;
  const [open, setOpen] = React.useState(false);
  const [openCreateQuotationDialog, setOpenCreateQuotationDialog] = React.useState(false);
  const [createBtnClicked, setCreateBtnClicked] = useState(false);
  const [hideCustomer, setHideCustomer] = React.useState(true);
  const [clickedSearchCustomer, setClickedSearchCustomer] = React.useState(false);
  const [errorPhone, setErrorPhone] = React.useState(true);
  const [errorEmail, setErrorEmail] = React.useState(true);
  const [requiredEmail, setRequiredEmail] = React.useState(true);
  const [limitCusName, setLimitCusName] = useState(true);
  const [isArabicNameValid, setIsArabicNameValid] = useState(true);
  const [showArabicNameError, setShowArabicNameError] = useState(false);
  const [errorSearchNationalId, setErrorSearchNationalId] = React.useState(true);
  const comexSettingsEntity = useAppSelector(state => state.comexSettings.entity);
  const filterCurrency = currencyRateList.filter(c => c.buyFrom.name === currencyName)[0];
  const [isSaveButtonClicked, setIsSaveButtonClicked] = useState(false);
  const [isSaveButtonClicked2, setIsSaveButtonClicked2] = useState(false);
  const [errMsgCurrency, setErrMsgCurrency] = useState('');
  const [operationTime, setOperationTime] = useState(true);
  const [loadingSpinner, setLoadingSpinner] = useState(true);
  const [validationForCommodity, setValidationForCommodity] = useState(true);
  const [operationStartTimeDisplay, setOperationStartTimeDisplay] = useState('');
  const [operationEndTimeDisplay, setOperationEndTimeDisplay] = useState('');
  const [errorName, setErrorName] = useState('');
  const [countryCode, setCountryCode] = useState('');
  const [preventMultipleClick, setPreventMultipleClick] = useState(false);
  const [convertLimitAmount, setConvertLimitAmount] = useState(0);
  const dateAndTime = moment(quotationEntity?.createdDate).format('yyyy/MM/DD HH:mm:ss');

  const currentDate = `${formatTwoDigits(tempDate.getMonth() + 1)}/${formatTwoDigits(tempDate.getDate())}/${tempDate.getFullYear()}`;
  //   const [kuwaitDinarCurrencyIndexId, setKuwaitDinarCurrencyIndexId] = useState(0);
  //   const [malaysiaRinggitCurrencyIndexId, setMalaysiaRinggitCurrencyIndexId] = useState(0);
  //   const [kwdToMyrExchangeRate, setKwdToMyrExchangeRate]=useState(0);
  const bankFeeInMYRList = [] as Array<IComexBankFee>;
  // const userLocalStart = moment.tz(FRIDAY_PRAYER_START_TIME, 'HH:mm:ss', 'Asia/Kuala_Lumpur').local().format('hh:mm A');

  const [itemFee, setItemFee] = useState(0);
  const [commissionPrice, setCommissionPrice] = useState(0);
  const [itemTotalAmount, setItemTotalAmount] = useState(0);
  const [bankFeeLastIndex, setBankFeeLastIndex] = useState(0);
  const [localStart, setLocalStart] = React.useState<any>(new Date('2018-01-01T19:30:00.000Z'));
  const [localEnd, setLocalEnd] = React.useState<any>(new Date('2018-01-01T17:29:00.000Z'));
  const [transactionFee, setTransactionFee] = useState(0);
  const [transactionFeeInQuotationCurrency, setTransactionFeeInQuotationCurrency] = useState(0);

  const trimmedIc = cusIc?.trim();
  const emailExist = customers?.filter(c => c?.email === cusEmail);
  const icExist = customers?.filter(c => c?.ic === trimmedIc);
  const newCustWithExistingEmail = icExist?.length === 0 && emailExist?.length > 0 && cusEmail !== '';
  const numFormatter = Intl.NumberFormat('en-US');
  const [errorPhoneExist, setErrorPhoneExist] = useState('');
  const [quotationType, setQuotationType] = useState<string>((props.location.state as IQuotationType)?.selectedQuotationOption ?? '');

  // Display-only override: show the real configured Lump Sum fee amount instead of the
  // backend's rounded value. Does not feed the save payload (see quotationValues below).
  const activeBank = isNew ? bankEntity : (quotationEntity?.bank ?? bankEntity);
  const isCommissionMode = isCommissionModeForBank(quotationType === 'local', activeBank);
  const currencyIdForFiltering = resolveCurrencyIdForFiltering(isDefaultCurrency, activeBank?.currencyId, filterCurrency?.buyFrom?.id);

  const displayTransactionFee = useMemo(
    () => (isCommissionMode ? null : resolveLumpSumFeeAmount(bankFeeList, amountV, currencyIdForFiltering)),
    [bankFeeList, amountV, currencyIdForFiltering, isCommissionMode]
  );
  const displayTransactionFeeInQuotationCurrency = useMemo(() => {
    if (isCommissionMode) return null;
    const quotationCurrencyFilterId = resolveCurrencyIdForFiltering(!isDefaultCurrency, currencyIdForFiltering, filterCurrency?.buyFrom?.id);
    return resolveLumpSumFeeAmount(bankFeeList, amountV, quotationCurrencyFilterId);
  }, [bankFeeList, amountV, isDefaultCurrency, filterCurrency, currencyIdForFiltering, isCommissionMode]);

  // Add new state for calculation results
  const calculationResult = useAppSelector(selectCalculationResult);
  const calculationLoading = useAppSelector(selectCalculationLoading);
  const [hasCalculated, setHasCalculated] = useState(false);
  const isCalculatingRef = useRef(false);
  const prevCalcParamsRef = useRef(null);
  const [hasRecalculated, setHasRecalculated] = useState(false);
  const isMountedRef = useRef(true);
  const [isCalcStale, setIsCalcStale] = useState(false);
  const [retryCalcTrigger, setRetryCalcTrigger] = useState(0);
  const desiredCalcParamsRef = useRef<any>(null);

  const getMinDate = () => {
    const validityDays = quotationEntity?.bank?.quotationValidityDays;
    const validUntil = quotationEntity?.validUntil;
    const createdDate = quotationEntity?.createdDate;

    if (validUntil) {
      return moment(validUntil, 'YYYY/MM/DD').add(1, 'days').toDate();
    }

    if (createdDate) {
      const baseDate = moment(createdDate);
      return validityDays ? baseDate.clone().add(validityDays, 'days').toDate() : baseDate.toDate();
    }

    return null;
  };

  const [valueValidUntil, setValueValidUntil] = React.useState(() => {
    const minDate = getMinDate();
    return minDate ? moment(minDate).format('YYYY/MM/DD') : moment(new Date()).format('YYYY/MM/DD');
  });
  const [openCalendarValidUntil, setOpenCalendarValidUntil] = useState(false);

  useEffect(() => {
    if (!isNew) {
      if (quotationEntity?.validUntil) {
        setValueValidUntil(moment(quotationEntity.validUntil).format('YYYY/MM/DD'));
      } else {
        const minDate = getMinDate();
        if (minDate) {
          setValueValidUntil(moment(minDate).subtract(1, 'days').format('YYYY/MM/DD'));
        } else {
          setValueValidUntil(moment(new Date()).format('YYYY/MM/DD'));
        }
      }
    }
  }, [quotationEntity]);

  const checkPhoneNumber = async (phoneNumber, customerIc) => {
    try {
      const result = await dispatch(verifyExistingCustomerPhoneNumber({ phoneNumber, customerIc }));

      if (result.meta.requestStatus === 'rejected') {
        setErrorPhoneExist('Error checking phone number');
      } else if (result.meta.requestStatus === 'fulfilled') {
        if (result.payload === true) {
          setErrorPhoneExist(translate('register.messages.error.phoneexists'));
        } else {
          setErrorPhoneExist('');
        }
      }
    } catch (error) {
      console.error('Error checking phone number:', error);
      setErrorPhoneExist('Error checking phone number');
    }
  };

  useEffect(() => {
    const isCustomerLoginEnabled = isNew ? (bankEntity?.enableCustomerLogin !== false) : (quotationEntity?.bank?.enableCustomerLogin !== false);
    if (!isCustomerLoginEnabled) {
      // Clear any stale phone error when customer login is disabled
      setErrorPhoneExist('');
      return;
    }
    if (phone) {
      checkPhoneNumber(phone, trimmedIc);
    }
  }, [phone, trimmedIc, bankEntity, quotationEntity?.bank]);

  const handleClickToOpen = () => {
    setOpen(true);
    //   setOpenCreateQuotationDialog(true);
  };
  const handleToClose = () => {
    setOpen(false);
    //   setOpenCreateQuotationDialog(false);
  };
  const [value, setValue]: any = useState();
  const handleClose = () => {
    setOpenCreateQuotationDialog(false);
    if (isNew) {
      historyBack.push('/home');
      dispatch(setQuotationTypeReducer(quotationType));
    } else {
      props.history.push(`/quotation/purchase/${props.match.params.id}`);
      dispatch(setQuotationTypeReducer(quotationType));
    }
  };
  const validateCurrency = () => {
    setOpenCreateQuotationDialog(true);
    setIsSaveButtonClicked(true);
    if (filterCurrency?.buyFrom?.active === false) {
      setErrMsgCurrency(translate('comexApp.quotation.currencyIsInactive'));
    } else {
      setErrMsgCurrency('');
    }
  };

  useEffect(() => {
    if (Storage.session.get('locale') === 'ar-ly' && itemDescription !== '' && itemDescription !== undefined) {
      const data = {
        q: itemDescription,
        source: 'en',
        target: 'ar',
        api_key: '',
      };
      axios
        .post(`https://translate.argosopentech.com/translate`, data)
        .then(response => {
          if (response?.data?.translatedText) {
            setItemDescriptionInArabic(response?.data?.translatedText);
          } else {
            setItemDescriptionInArabic(itemDescription);
          }
        })
        .catch(error => {
          console.warn('Translation failed:', error);
          setItemDescriptionInArabic(itemDescription);
        });
    }
  }, [itemDescription, Storage.session.get('locale')]);

  useEffect(() => {
    if (bankIdData) {
      // dispatch(getFeeListByBankId(bankIdData));
      if (quotationType === 'international') {
        dispatch(
          getFeeListByBankIdAndCommodityType({
            bankId: bankIdData,
            commodityType: 'International',
          })
        );
      } else if (quotationType === 'local') {
        dispatch(
          getFeeListByBankIdAndCommodityType({
            bankId: bankIdData,
            commodityType: 'Local',
          })
        );
      }
    }
  }, [bankIdData]);

  useEffect(() => {
    // setBankFeeLastIndex(bankFeeList.length - 1);
    localStorage.setItem('print', 'false');
  }, [bankFeeList]);

  const resetCalculationLocalState = () => {
    // Reset calculation results
    setItemPrice(0);
    setItemQuantity(0);
    setItemQuantityUnit('');
    setTransactionFee(0);
    setTransactionFeeInQuotationCurrency(0);
    setCommissionPrice(0);
    setItemTotalAmount(0);
    setItemDescription('');
    setItemDescriptionInArabic('');
    setConvertLimitAmount(0);
    setItemFee(0);
    setIsDefaultCurrency(false);
    setDisplayCurrencyName('');
    setHasCalculated(false);
    setHasRecalculated(false);
    prevCalcParamsRef.current = null;
    isCalculatingRef.current = false;
    setIsCalcStale(false);
    desiredCalcParamsRef.current = null;

    setCurrencyName('');
    setAmount(0);
    setDebouncedAmountV(0);
    setItemName('');
  };

  useEffect(() => {
    isMountedRef.current = true;
    if (isNew) {
      dispatch(reset());
      dispatch(resetCalculation());
      resetCalculationLocalState();
    } else {
      setClickedSearchCustomer(true);
      setHasCalculated(true);
      setHasRecalculated(false);
      dispatch(getEntity(props.match.params.id)).then(res => {
        if (!isMountedRef.current) return;

        const commodity = res.payload['data'].commodity;
        const ownership = commodity?.ownership;

        // set quotation type berdasarkan ownership
        if (ownership === 'Local') {
          setQuotationType('local');
        } else if (ownership === null) {
          setQuotationType('international');
        }

        let newItemQuantity = (res.payload['data'].amount * res.payload['data'].currencyRate) / res.payload['data'].commodity.price;
        newItemQuantity = Math.round(newItemQuantity * 100) / 100;
        setItemName(res.payload['data']?.commodity?.name);
        setAmount(res.payload['data'].amount);
        setDebouncedAmountV(res.payload['data'].amount);
        setAmountDisplayed(res.payload['data'].amount);

        const feeCurrency = res.payload['data']?.bank?.feeCurrency ?? '';
        setCurrencyName(res.payload['data'].currencyIndex.name || '');

        setItemDescription(res.payload['data'].commodity.description);
        setItemPrice(res.payload['data'].commodity.price);
        setItemQuantity(newItemQuantity);
        setItemQuantityUnit(res.payload['data'].commodity.unit);
        setItemFee(res.payload['data'].fee);
        setCommissionPrice(res.payload['data'].commission);
        if (res.payload['data'].commission > 0) {
          setTransactionFee(res.payload['data'].commission);
        } else {
          setTransactionFee(res.payload['data'].fee);
        }
        setTransactionFeeInQuotationCurrency(res.payload['data'].feeInQuotationCurrency || 0);
        setItemTotalAmount(res.payload['data'].totalAmount);
        setCusName(res.payload['data'].customer.name);
        setCusNameAr(res.payload['data'].customer.nameArabic);
        setCusIc(res.payload['data'].customer.ic);
        setCusIdSearch(res.payload['data'].customer.ic);
        setNationality(res.payload['data'].customer.nationality);
        setCountryCode(countryList.find(country => country.Desc_en === bankEntity?.country)?.code.toLowerCase());
        setPhone(res.payload['data'].customer.tel);
        setCusEmail(res.payload['data'].customer.email);
        setBankIdData(res.payload['data']?.bank?.id);

        prevCalcParamsRef.current = {
          selectedCurrency: res.payload['data'].currencyIndex.name || '',
          amount: res.payload['data'].amount,
          itemName: res.payload['data']?.commodity?.name,
          commodityId: commodity.id,
          bankId: res.payload['data']?.bank?.id,
          quotationType: ownership === 'Local' ? 'local' : 'international',
          displayCurrencyName: res.payload['data']?.feeCurrencyIndex || '',
        };
      });
    }
    dispatch(getCurrencies({}));
    dispatch(getAccount());
    dispatch(getCurrencyRates({}));
    dispatch(getBankByBranchId(account?.branchId));
    dispatch(getBranch(account?.branchId));
    dispatch(getCustomers({}));
    const getComexSettingDispatch = async () => {
      const result = await dispatch(getComexSetting(1));
      if (!isMountedRef.current) return;
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      if (result.payload && result.payload?.status === 200) {
        setIsComexSettingStatus(200);
      }
    };
    getComexSettingDispatch();

    return () => {
      isMountedRef.current = false;
    };
  }, [props.match.params.id, props.location.key]);

  // Debounce amount changes to prevent too many API calls
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setDebouncedAmountV(amountV);
    }, 500);

    return () => clearTimeout(timeoutId);
  }, [amountV]);

  useEffect(() => {
    if (account?.login !== undefined && comexSettingsEntity.serverStatus && isComexSettingStatus === 200) {
      const operationStartMalayTime = moment(comexSettingsEntity?.operationStartTime).format('HH:mm:ss');
      const startDateTime = new Date(currentDate + ' ' + operationStartMalayTime);
      const currDate = new Date();
      const startHourMin = operationStartMalayTime.split(':');
      if (parseInt(startHourMin[0], 10) > currDate.getHours()) startDateTime.setDate(startDateTime.getDate() - 1);
      const startTime = Date.parse(startDateTime.toString());
      localStart.setHours(startHourMin[0]);
      localStart.setMinutes(startHourMin[1]);
      const operationEndMalayTime = moment(comexSettingsEntity?.operationEndTime).format('HH:mm');
      const currentDateTime = Date.now();
      const endHourMin = operationEndMalayTime.split(':');

      const endDateTime = new Date(currentDate + ' ' + operationEndMalayTime);
      if (parseInt(endHourMin[0], 10) <= currDate.getHours()) endDateTime.setDate(endDateTime.getDate() + 1);

      const endTime = Date.parse(endDateTime.toString());
      localEnd.setHours(endHourMin[0]);
      localEnd.setMinutes(endHourMin[1]);
      const currentTime = moment().format('HH:mm').split(':');

      if (quotationType === 'local') {
        setOperationTime(true);
      } else {
        if (startTime <= currentDateTime && currentDateTime <= endTime) setOperationTime(true);
        else setOperationTime(false);
      }
    }
  }, [comexSettingsEntity, isComexSettingStatus, quotationType]);
  useEffect(() => {
    if (bankEntity?.id !== undefined) {
      setBankIdData(bankEntity?.id);
    }
  }, [bankEntity]);

  useEffect(() => {
    if (bankEntity !== null && bankEntity !== undefined) {
      dispatch(getCommoditiesByBankId(bankEntity?.id));
      setBankIdData(bankEntity?.id);
      if (isNew) {
        setCurrencyName(bankEntity?.currencyIndex?.name);
      }

      const feeCurrency = bankEntity?.feeCurrency ?? '';
      const localFeeCurrency = bankEntity?.localFeeCurrency ?? '';

      let newIsDefaultCurrency = false;

      if (quotationType === 'local') {
        newIsDefaultCurrency = localFeeCurrency.toLowerCase() === 'bank default currency'.toLowerCase();
      } else {
        newIsDefaultCurrency = feeCurrency.toLowerCase() === 'bank default currency'.toLowerCase();
      }
      setIsDefaultCurrency(newIsDefaultCurrency);

      if (newIsDefaultCurrency) {
        setDisplayCurrencyName(bankEntity?.currencyIndex?.name);
      } else {
        setDisplayCurrencyName(currencyName);
      }
    }
  }, [bankEntity, quotationType]);

  useEffect(() => {
    const feeCurrency = quotationType === 'local' ? bankEntity?.localFeeCurrency ?? '' : bankEntity?.feeCurrency ?? '';
    if (feeCurrency && feeCurrency.toLowerCase() === 'bank default currency'.toLowerCase()) {
      setDisplayCurrencyName(bankEntity?.currencyIndex?.name);
    } else {
      setDisplayCurrencyName(currencyName);
    }
  }, [currencyName]);

  useEffect(() => {
    if (updateSuccess) {
      if (isNew) {
        setOpenCreateQuotationDialog(true);
      } else {
        handleClose();
      }
      setPreventMultipleClick(false);
    } else {
      setOpenCreateQuotationDialog(false);
    }
  }, [updateSuccess, isNew, openCreateQuotationDialog]);

  useEffect(() => {
    if (cusIdSearch) {
      customerSearch();
    }
  }, [cusIdSearch]);

  const handlerCurrency = event => {
    const selectedCurrency = event.target.value;
    setCurrencyName(selectedCurrency);
    setIsCalcStale(true);
  };

  const handlerItem = event => {
    const selectedCommodity = event.target.value;
    setItemName(selectedCommodity);
    setIsCalcStale(true);
  };

  const [filteredCommodities, setFilteredCommodities] = useState<ICommodity[]>(commodities);

  useEffect(() => {
    let updatedFilteredCommodities = commodities;
    if (quotationType === 'international') {
      updatedFilteredCommodities = commodities.filter(item => item.ownership !== 'Local');
    } else if (quotationType === 'local') {
      updatedFilteredCommodities = commodities.filter(item => item.ownership === 'Local');
    }

    setFilteredCommodities(updatedFilteredCommodities);
  }, [quotationType, commodities]);

  // CALCULATION IN BE
  useEffect(() => {
    // Reset calculated values when amount is 0 or empty
    if (debouncedAmountV <= 0) {
      setItemPrice(0);
      setItemQuantity(0);
      setItemQuantityUnit('');
      setTransactionFee(0);
      setTransactionFeeInQuotationCurrency(0);
      setCommissionPrice(0);
      setItemTotalAmount(0);
      setItemDescription('');
      setItemDescriptionInArabic('');
      setConvertLimitAmount(0);
      setItemFee(0);
      setHasCalculated(false);
      setHasRecalculated(false);
      prevCalcParamsRef.current = null;
      setIsCalcStale(false);
      desiredCalcParamsRef.current = null;
      return;
    }

    const isDataReady = currencyName && debouncedAmountV > 0 && itemName && bankIdData && filteredCommodities.length > 0;

    if (!isDataReady) return;

    const selectedCommodity = filteredCommodities.find(c => c.name === itemName);
    if (!selectedCommodity) return;

    // Prepare current calculation params
    const currentParams = {
      selectedCurrency: currencyName,
      amount: debouncedAmountV,
      itemName,
      commodityId: selectedCommodity.id,
      bankId: bankIdData,
      quotationType,
      displayCurrencyName,
      quotationId: isNew ? null : (quotationEntity?.id ?? null),
    };

    // Always track the latest desired params before any blocking check
    desiredCalcParamsRef.current = currentParams;

    // If a calculation is already in progress, return — retry will be triggered when it finishes
    if (isCalculatingRef.current || calculationLoading) return;

    // Check if in edit mode and params haven't changed
    if (!isNew && prevCalcParamsRef.current) {
      const hasChanged =
        prevCalcParamsRef.current.selectedCurrency !== currentParams.selectedCurrency ||
        prevCalcParamsRef.current.amount !== currentParams.amount ||
        prevCalcParamsRef.current.itemName !== currentParams.itemName ||
        prevCalcParamsRef.current.commodityId !== currentParams.commodityId ||
        prevCalcParamsRef.current.bankId !== currentParams.bankId ||
        prevCalcParamsRef.current.quotationType !== currentParams.quotationType ||
        prevCalcParamsRef.current.displayCurrencyName !== currentParams.displayCurrencyName;

      if (!hasChanged) {
        setIsCalcStale(false);
        return;
      }
      setHasRecalculated(true);
    }

    if (isNew) {
      setHasCalculated(false);
    }

    // Store current params for next comparison
    prevCalcParamsRef.current = currentParams;
    isCalculatingRef.current = true;

    const startedParams = currentParams;

    dispatch(calculateQuotation(currentParams))
      .unwrap()
      .then(() => {
        isCalculatingRef.current = false;
        // Check if params changed while this calculation was running
        const desired = desiredCalcParamsRef.current;
        const paramsChanged = desired && (
          desired.selectedCurrency !== startedParams.selectedCurrency ||
          desired.amount !== startedParams.amount ||
          desired.itemName !== startedParams.itemName ||
          desired.commodityId !== startedParams.commodityId
        );
        if (paramsChanged) {
          // Trigger a retry — the effect will re-run with updated params
          setRetryCalcTrigger(t => t + 1);
        } else {
          setIsCalcStale(false);
        }
      })
      .catch(() => {
        isCalculatingRef.current = false;
        setIsCalcStale(false);
      });

  }, [currencyName, debouncedAmountV, itemName, bankIdData, quotationType,
    isDefaultCurrency, filteredCommodities, isNew, displayCurrencyName, retryCalcTrigger]);

  // Update state when calculation results are received
  useEffect(() => {
    if (isNew && (!currencyName || amountV <= 0 || !itemName)) {
      return;
    }

    if (calculationResult && !calculationLoading) {
      // Update all calculated values from the backend response
      setItemPrice(calculationResult.itemPrice || 0);
      setItemQuantity(calculationResult.itemQuantity || 0);
      setItemQuantityUnit(calculationResult.itemQuantityUnit || '');
      setTransactionFeeInQuotationCurrency(calculationResult.transactionFeeInQuotationCurrency || 0);
      setCommissionPrice(calculationResult.commissionPrice || 0);
      setItemTotalAmount(calculationResult.itemTotalAmount || 0);
      setItemDescription(calculationResult.itemDescription || '');
      setItemDescriptionInArabic(calculationResult.itemDescriptionInArabic || '');
      setConvertLimitAmount(calculationResult.convertLimitAmount || 0);
      setIsDefaultCurrency(calculationResult.isDefaultCurrency || false);
      setDisplayCurrencyName(calculationResult.displayCurrencyName);

      // transactionFee (display) = commission if commission mode, else fee
      // itemFee (saved to DB)    = 0 if commission mode, else fee
      if (calculationResult.commissionPrice > 0) {
        setTransactionFee(calculationResult.commissionPrice || 0);
        setItemFee(0);
      } else {
        setTransactionFee(calculationResult.transactionFee || 0);
        setItemFee(calculationResult.transactionFee || 0);
      }

      // Mark that calculation has been done
      setHasCalculated(true);
    }
  }, [calculationResult, calculationLoading]);

  const shouldDisplayFeeInQuotationCurrency = useMemo(() => {
    if (!isDefaultCurrency) return false;

    if (isNew) {
      return bankEntity?.displayFeeInTransactionCurrency ?? false;
    }

    // Edit mode:
    return quotationEntity?.bank?.displayFeeInTransactionCurrency ?? bankEntity?.displayFeeInTransactionCurrency ?? false;
  }, [
    isNew,
    isDefaultCurrency,
    quotationEntity?.bank?.displayFeeInTransactionCurrency,
    bankEntity?.displayFeeInTransactionCurrency,
    calculationResult,
    hasCalculated,
  ]);

  // Add loading indicator for calculations
  const renderCalculationStatus = () => {
    if (calculationLoading) {
      return (
        <div className="calculation-loading">
          <span className="spinner-border spinner-border-sm mr-2"></span>
          {translate('comexApp.quotation.calculating')}
        </div>
      );
    }
    return null;
  };

  const handlerNationality = event => {
    if (Storage.session.get('locale') === 'en') {
      const selectedCountry = event.target.value;
      setNationality(selectedCountry);
      const countryIndex = countryList.find(c => c.Desc_en === selectedCountry);
      setNationalityArabic(countryIndex['Desc_ar']);
    } else {
      const selectedCountry = event.target.value;
      setNationalityArabic(selectedCountry);
      const countryIndex = countryList.find(c => c.Desc_ar === selectedCountry);
      setNationality(countryIndex['Desc_en']);
    }
  };
  function toEnglishDigits(str) {
    let e = '۰'.charCodeAt(0);

    // convert persian digits [۰۱۲۳۴۵۶۷۸۹]
    // str = str.replace(/[۰-۹]/g, function(t) {
    //   return t.charCodeAt(0) - e;
    // });

    // convert arabic indic digits [٠١٢٣٤٥٦٧٨٩]
    e = '٠'.charCodeAt(0);
    str = str.replace(/[٠-٩]/g, function (t) {
      return t.charCodeAt(0) - e;
    });
    return str;
  }
  const handlerAmount = event => {
    const amount = event.target.value.replace(/,/g, '').replace(/-/g, '');
    setAmount(toEnglishDigits(amount));
    const selectedAmount = toEnglishDigits(amount).toLocaleString();
    setAmountDisplayed(selectedAmount);
    setIsCalcStale(true);
  };

  // Remove characters (if any) from Amount Input when the user clicks or focusOut of the amount input
  const handleDigits = event => {
    const amount = event.target.value.replace(/[^0-9.]+/g, '');
    setAmount(amount);
    const formattedAmount = Number(amount).toLocaleString();
    setAmountDisplayed(formattedAmount);
  };

  const [disable, setDisable] = useState(true);

  const handleArabicNameChange = event => {
    const arabicTextOnly = event.target.value
      .replace(/[^\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF\u0660-\u0669\u06F0-\u06F9\u0030-\u0039\s]/g, '')
      .replace(/^\s+/, '');
    setCusNameAr(arabicTextOnly);
    const arabicCount = (arabicTextOnly.match(/[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]/g) || []).length;
    setIsArabicNameValid(arabicCount >= 4);
  };

  const handlePhoneNumberDefaultCountryCode = () => {
    // if (!isNew) return 'us';
    const bankCountryName = bankEntity?.country;
    const defaultCode = countryList.find(country => country.Desc_en === bankCountryName)?.code.toLowerCase();
    return defaultCode;
  };

  const handlePhone = (...args) => {
    setPhone(args[3]);
  };

  const handleBack = () => {
    if (isNew) {
      props.history.push(`/home`);
    } else {
      historyBack.goBack();
    }
  };

  function customerSearch() {
    let found: ICustomer;
    const entity: ICustomerQueryParam = {
      ic: trimmedIc,
      bId: isNew ? bankEntity?.id : quotationEntity?.bank?.id,
    };
    dispatch(getEntityByIcAndBankId(entity)).then(res => {
      found = res?.payload['data'] ?? {};

      if (Object?.keys(found)?.length === 0) {
        setNewEditCus(true);
        setCusName('');
        setCusNameAr('');
        setNationality('');
        setPhone(countryCode);
        setCountryCode(handlePhoneNumberDefaultCountryCode());
        setCusEmail('');
        setOldEditCusId(null);
        setDisable(false);
        setOpen(true);
        fillOptionalEmail();
        //       alert(translate('comexApp.quotation.notFoundAlert'));
      } else {
        setCusName(found?.name);
        setCusNameAr(found?.nameArabic);
        setNationality(found?.nationality);
        setPhone(found?.tel);
        setCusEmail(found?.email);
        dispatch(getVerifyExistingEmailUser(found?.email));
        setOldEditCusId(found?.id);
        // setDisable(true);
        setDisable(false);
      }
      setHideCustomer(false);
    });

    setErrorSearchNationalId(true);
    setClickedSearchCustomer(true);
  }
  useEffect(() => {
    const cusNameCheck = cusName.length <= 100;
    if (cusNameCheck === false) {
      setLimitCusName(false);
    } else {
      setLimitCusName(true);
    }
  });

  // For IBAN Number
  const ibanEntity = useAppSelector(state => state.iban.entity);
  const qId = props.match.params.id;
  useEffect(() => {
    if (!isNew && quotationType === 'local') {
      dispatch(getEntityByQuotationId(qId));
    }
  }, [isNew, quotationType, qId]);

  const [ibanValue, setIbanValue] = useState('');

  const [ibanTouched, setIbanTouched] = useState(false);

  const handleIBANInputChange = event => {
    setIbanValue(event.target.value);
    setIbanTouched(true);
  };

  useEffect(() => {
    if (ibanEntity?.id) {
      setIbanValue(ibanEntity.ibanNumber || '');
    } else {
      setIbanValue('');
    }
  }, [ibanEntity]);

  const saveCustomer = async () => {
    // Prevent multiple clicks immediately
    if (preventMultipleClick) return;

    setLimitCusName(true);
    setRequiredEmail(true);
    setErrorEmail(true);
    setErrorPhone(true);
    setPreventMultipleClick(true);
    let chosenCustomer: ICustomer;
    try {
      if (clickedSearchCustomer) {
        const isCustomerLoginEnabled = isNew ? (bankEntity?.enableCustomerLogin !== false) : (quotationEntity?.bank?.enableCustomerLogin !== false);
        const phoneCheck = isCustomerLoginEnabled
          ? (phone !== "" && phone !== null && phone !== undefined && phone !== countryCode && phone.length > 3)
          : true; // phone is optional when customer login is disabled
        const cusNameCheck = cusName.length <= 100;
        const emailRequiredCheck= cusEmail.replace(' ','')==='';
        const emailCheck= cusEmail.replace(' ','')!=='' && (verifyEmailUser?.id=== undefined  || trimmedIc===verifyEmailUser?.login);
        const emailValue = cusEmail === "" ? placeholderEmail() : cusEmail;
        const amountLimitCheck = amountV > convertLimitAmount;
        const errorPhoneExistCheck = !isCustomerLoginEnabled ? true : errorPhoneExist === '';
        const amountValidCheck = amountV > 0;
        if (phoneCheck && cusNameCheck && !newCustWithExistingEmail && !amountLimitCheck && errorPhoneExistCheck && isArabicNameValid && amountValidCheck) {
          if (isNew) {
            const entity: ICustomerQueryParam = {
              ic: trimmedIc,
              bId: bankIdData,
            };
            const response = await dispatch(getEntityByIcAndBankId(entity));
            const found = response.payload['data'];
            if (Object.keys(found).length === 0) {
              setNewEditCus(true);
              const newCustomer = {
                ic: trimmedIc,
                name: cusName,
                nationality: cusNationality,
                tel: phone,
                email: emailValue,
                bankId: bankIdData,
                nameArabic: cusNameAr,
              };
              const res = await dispatch(createCustomer(newCustomer));
              chosenCustomer = res.payload['data'];
            } else {
              setOldEditCusId(found.id);
              const updateExistingCustomer = {
                ...found,
                id: found.id,
                ic: trimmedIc,
                name: cusName,
                nationality: cusNationality,
                tel: phone,
                email: emailValue,
                bankId: bankIdData,
                nameArabic: cusNameAr,
              };
              const updateExCustomer = JSON.stringify(found) === JSON.stringify(updateExistingCustomer);
              if (!updateExCustomer) {
                const res = await dispatch(updateCustomer(updateExistingCustomer));
                chosenCustomer = res.payload['data'];
              } else {
                chosenCustomer = found;
              }
            }
          } else {
            const entity: ICustomerQueryParam = {
              ic: trimmedIc,
              bId: quotationEntity?.bank?.id,
            };
            const response = await dispatch(getEntityByIcAndBankId(entity));
            const found = response.payload['data'];
            if (Object.keys(found).length === 0) {
              setNewEditCus(true);
              const newCustomer = {
                ic: trimmedIc,
                name: cusName,
                nationality: cusNationality,
                tel: phone,
                email: emailValue,
                bankId: bankIdData,
                nameArabic: cusNameAr,
              };
              const res = await dispatch(createCustomer(newCustomer));
              chosenCustomer = res.payload['data'];
            } else {
              setOldEditCusId(found.id);
              const updateExistingCustomer = {
                ...found,
                id: found.id,
                ic: trimmedIc,
                name: cusName,
                nationality: cusNationality,
                tel: phone,
                email: emailValue,
                bankId: bankIdData,
                nameArabic: cusNameAr,
              };
              const updateExCustomer = JSON.stringify(found) === JSON.stringify(updateExistingCustomer);
              if (!updateExCustomer) {
                const res = await dispatch(updateCustomer(updateExistingCustomer));
                chosenCustomer = res.payload['data'];
              } else {
                chosenCustomer = found;
              }
            }
          }
          const isEditCustomer = JSON.stringify(chosenCustomer) === JSON.stringify(quotationEntity.customer);
          const validUntilDateString = valueValidUntil
            ? moment.utc(valueValidUntil, 'YYYY/MM/DD').startOf('day').toISOString()
            : null;

          // const ibanToSave: IIban = {
          //   ...ibanEntity,
          //   ibanNumber: ibanValue,
          //   customerId: quotationEntity?.customer?.id,
          //   quotationId: quotationEntity?.id,
          //   ibanBankName: bankEntity?.name || '',
          //   ibanBranchName: branchEntity?.name || ''
          // };

          const quotationValues = {
            ...quotationEntity,
            amount: +amountV,
            fee: itemFee,
            commission: commissionPrice,
            totalAmount: itemTotalAmount,
            description: itemDescription,
            descriptionInArabic: itemDescriptionInArabic,
            commodityUnitPrice: itemPrice,
            commodityQuantity: itemQuantity,
            commodityUnit: itemQuantityUnit,
            currencyRate: currencyRateList?.find(currencyRate => currencyRate.buyFrom.name === currencyName)?.exchangeRate,
            buyCurrency: currencyName,
            branchId: branchEntity?.id,
            branch: branchEntity,
            customerId: chosenCustomer.id,
            customer: chosenCustomer,
            commodityId: commodities?.find(commodity => commodity.name === itemName)?.id,
            commodity: commodities?.find(commodity => commodity.name === itemName),
            currencyIndexId: currencyRateList?.find(currencyRate => currencyRate.buyFrom.name === currencyName)?.buyFrom?.id,
            currencyIndex: currencyRateList?.find(currencyRate => currencyRate.buyFrom.name === currencyName)?.buyFrom,
            bankManagerApproval: null,
            bankCustomerApproval: null,
            smsLanguage: null,
            status: 'Quoted',
            feeCurrencyIndex: displayCurrencyName,
            feeInQuotationCurrency: transactionFeeInQuotationCurrency,
            ...(!isNew && { validUntil: validUntilDateString }),
            timesExtended: quotationEntity?.timesExtended + 1,
            // iban: ibanToSave,
          };
          const customerEditQuo = { ...quotationValues, customerId: oldEditCusId };
          if (!isNew) {
            if (!isEditCustomer && newEditCus) {
              setLoadingSpinner(false);
              setIsSaveButtonClicked2(true);
            }
            setLoadingSpinner(false);
            setIsSaveButtonClicked2(true);
            // if(preventMultipleClick === false) {
            await dispatch(updateEntity(quotationValues));

            // if (quotationType === 'local' && ibanToSave.id) {
            //   await dispatch(updateIban(ibanToSave));
            // }
            // }
          } else {
            setLoadingSpinner(false);
            setIsSaveButtonClicked2(true);
            // if(preventMultipleClick === false){
            await dispatch(createEntity(quotationValues));
            // }
          }
        }

        if (cusNameCheck === false) {
          setLimitCusName(false);
          setPreventMultipleClick(false);
        }

        if (!isArabicNameValid) {
          setShowArabicNameError(true);
          setPreventMultipleClick(false);
        }

        // if (emailRequiredCheck === true) {
        //  setRequiredEmail(false);
        //  setPreventMultipleClick(false);
        // }
        if (newCustWithExistingEmail) {
          setErrorEmail(false);
          setPreventMultipleClick(false);
        }
        if (phoneCheck === false) {
          setErrorPhone(false);
          setPreventMultipleClick(false);
        }
        if (amountLimitCheck === true) {
          setPreventMultipleClick(false);
        }
        if (errorPhoneExistCheck === false) {
          setPreventMultipleClick(false);
        }
        if (!amountValidCheck) {
          setPreventMultipleClick(false);
        }
      } else {
        setErrorSearchNationalId(false);
        setPreventMultipleClick(false);
      }
    } catch (error) {
      // Reset on error
      setPreventMultipleClick(false);
      console.error('Error saving customer:', error);
    }
  };

  const checkExistingEmail = emailCheck => {
    if (emailExist?.length > 0) {
      dispatch(getVerifyExistingEmailUser(emailCheck));
      setCusEmail(emailCheck);
      // setRequiredEmail(true);
    } else {
      setCusEmail(emailCheck);
      // setRequiredEmail(false);
      setErrorEmail(true);
    }
  };

  // Auto-generated customer email; Boubyan banks must not carry the "alshmokh" prefix
  const placeholderEmail = () =>
    (isBoubyanBank(isNew ? bankEntity : quotationEntity?.bank, quotationType === 'local') ? 'sender+' : 'alshmokhsender+') + trimmedIc + '@gmail.com';

  const fillOptionalEmail = () => {
    // You can modify the value of input1Value here as needed
    const optionalEmail = placeholderEmail();

    // Set the modified value to Input2
    setCusEmail(optionalEmail);
  };

  const StyledTextField = styled(TextField)({
    '& .MuiOutlinedInput-input': {
      textAlign: Storage.session.get('locale') === 'en' ? 'left' : 'right',
    },
  });

  const renderValidUntilField = () => {
    const validityDays = quotationEntity?.bank?.quotationValidityDays;
    const extensionDays = quotationEntity?.bank?.quotationMaxExtensionDays;
    const timesExtended = quotationEntity?.timesExtended ?? 0;

    const isExtensionAllowed = extensionDays !== null && timesExtended < 2;
    const minDate = getMinDate();

    const maxDate =
      minDate && extensionDays !== null
        ? moment(minDate)
            .add(extensionDays - 1, 'days')
            .toDate()
        : null;

    const errorMessage =
      extensionDays === null
        ? translate('comexApp.quotation.extensionNotAllowedDueToBankSettings')
        : timesExtended >= 2
        ? translate('comexApp.quotation.extensionLimitReached')
        : null;

    return (
      !isNew && (
        <>
          &nbsp;
          <Divider />
          &nbsp;
          <ThemeProvider theme={responsiveFont}>
            <Typography variant="h6" component="div">
              <strong>{translate('comexApp.quotation.quotationExtension')}</strong>
            </Typography>
          </ThemeProvider>
          &nbsp;
          <div className="form-group row mb-2" style={{ alignItems: 'center' }}>
            <div className="col-sm-3">
              <Label>{translate('comexApp.quotation.validUntil')}</Label>
            </div>
            <div className="col-sm-9">
              <LocalizationProvider locale={Storage.session.get('locale') === 'en' ? enUS : ar} dateAdapter={AdapterDateFns}>
                <MobileDatePicker
                  toolbarTitle={translate('entity.action.selectDate')}
                  okText={translate('entity.action.ok')}
                  cancelText={translate('entity.action.cancel')}
                  disablePast
                  inputFormat="yyyy/MM/dd"
                  mask="____/__/__"
                  views={['year', 'month', 'day']}
                  value={valueValidUntil}
                  onChange={newValue => {
                    if (newValue) {
                      setValueValidUntil(moment(newValue).format('yyyy/MM/DD'));
                    }
                  }}
                  open={openCalendarValidUntil}
                  onOpen={() => {
                    if (isExtensionAllowed) setOpenCalendarValidUntil(true);
                  }}
                  onClose={() => setOpenCalendarValidUntil(false)}
                  minDate={minDate}
                  maxDate={maxDate ?? undefined}
                  disabled={!isExtensionAllowed}
                  renderInput={params => (
                    <StyledTextField
                      size="small"
                      fullWidth
                      {...params}
                      onClick={() => {
                        if (isExtensionAllowed) {
                          setOpenCalendarValidUntil(true);
                        }
                      }}
                      error={!isExtensionAllowed}
                      helperText={!isExtensionAllowed ? errorMessage : ''}
                      InputProps={{
                        placeholder: 'yyyy/mm/dd',
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              edge="end"
                              onClick={() => {
                                if (isExtensionAllowed) {
                                  setOpenCalendarValidUntil(true);
                                }
                              }}
                            >
                              <EventIcon />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  )}
                />
              </LocalizationProvider>
            </div>
          </div>
          &nbsp;
        </>
      )
    );
  };

  let responsiveFont = createTheme();
  responsiveFont = responsiveFontSizes(responsiveFont);
  return (
    <>
      <Dialog open={open} onClose={handleToClose}>
        <DialogTitle></DialogTitle>
        <DialogContent>
          <DialogContentText style={{ color: 'black' }} className="mb-3">
            {translate('comexApp.quotation.customerNotFound')}
          </DialogContentText>
        </DialogContent>
        <DialogActions className="mx-3">
          <Button color="primary" onClick={handleToClose} autoFocus>
            {translate('comexApp.quotation.okButton')}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={openCreateQuotationDialog} onClose={handleClose} hidden={!isNew}>
        <DialogTitle></DialogTitle>
        <DialogContent>
          <DialogContentText style={{ color: 'black' }} className="mb-3">
            {translate('comexApp.quotation.quotationCreate', {
              quotationNo: <b>{quotationEntity?.id?.toString()}</b>,
              date: <b>{moment(quotationEntity?.createdDate).local().format('yyyy/MM/DD HH:mm:ss') || ''}</b>,
            })}
          </DialogContentText>
          <DialogContentText></DialogContentText>
        </DialogContent>
        <DialogActions className="mx-3">
          <Button color="primary" onClick={handleClose} autoFocus>
            {translate('comexApp.quotation.okButton')}
          </Button>
        </DialogActions>
      </Dialog>
      <div className="overlay" hidden={loadingSpinner}>
        <img
          src="../../content/images/loading.gif"
          style={{ alignContent: 'center', position: 'fixed', left: '46%', top: '40%', zIndex: '1000' }}
          hidden={loadingSpinner}
        />
      </div>
      &nbsp;
      <Row className="justify-content-center">
        <Col md="8" lg="6">
          <ThemeProvider theme={responsiveFont}>
            <Typography variant="h4" component="div">
              {translate('comexApp.quotation.home.createOrEditLabel')}
            </Typography>
          </ThemeProvider>
        </Col>

        <Row className="justify-content-center" style={{ marginTop: '12px' }}>
          <Col md="8" lg="6" className="round-border mt-1" style={{ padding: '28px 42px 28px 42px' }}>
            {loading ? (
              <h5>
                <Translate contentKey={'global.loading'} />
              </h5>
            ) : (
              <>
                <ThemeProvider theme={responsiveFont}>
                  <Typography variant="h6" component="div">
                    <strong>{translate('comexApp.quotation.orderInfoLabel')}</strong>
                  </Typography>
                </ThemeProvider>
                &nbsp;
                <ValidatedForm onSubmit={saveCustomer}>
                  <div className="form-group row" style={{ alignItems: 'center' }}>
                    <div className="col-sm-3">
                      <Label>{translate('comexApp.quotation.date')}</Label>
                    </div>
                    <div className="col-sm-9 box-space">
                      <ValidatedField
                        id="date"
                        name="date"
                        data-cy="date"
                        value={
                          quotationEntity?.lastModifiedDate
                            ? moment(quotationEntity?.lastModifiedDate).local().format('YYYY/MM/DD HH:mm:ss')
                            : quotationEntity?.createdDate
                            ? moment(quotationEntity?.createdDate).local().format('YYYY/MM/DD HH:mm:ss')
                            : ''
                        }
                        disabled
                      />
                    </div>
                  </div>
                  <div className="form-group row" style={{ alignItems: 'center' }}>
                    <div className="col-sm-3">
                      <Label>{translate('comexApp.quotation.amount')}</Label>
                      <Label style={{ color: 'red' }}>*</Label>
                    </div>
                    <div
                      className="row col-sm-9"
                      style={
                        Storage.session.get('locale') === 'en'
                          ? { paddingRight: '0px', paddingLeft: '24px' }
                          : { paddingRight: '24px', paddingLeft: '0px' }
                      }
                    >
                      <div className="col-5 col-sm-3 px-0 box-space">
                        <ValidatedField
                          id="currency_name_option"
                          name="currency_name"
                          data-cy="currency_name"
                          type="select"
                          onChange={handlerCurrency}
                          value={currencyName ?? ''}
                          required={filterCurrency?.buyFrom?.active === false}
                        >
                          <option key="0" />
                          {currencyRateList
                            ? currencyRateList
                                .filter(item => item.buyFrom.active)
                                .map(item => (
                                  <option value={item.buyFrom.name} key={item.id} disabled={item.buyFrom.active === false}>
                                    {item.buyFrom.name}
                                  </option>
                                ))
                            : null}
                        </ValidatedField>
                      </div>
                      <div className="col-7 col-sm-9 px-0 box-space">
                        <ValidatedField
                          id="amount"
                          name="amount"
                          data-cy="amount"
                          type={'text'}
                          onChange={handlerAmount}
                          onBlur={handleDigits}
                          value={amountDisplayed ?? ''}
                          required
                          min={1}
                          style={{
                            textAlign: Storage.session.get('locale') === 'en' ? 'left' : 'right',
                          }}
                        />
                      </div>
                      {amountV <= 0 && amountDisplayed !== '' && (
                        <Label className="p-0" style={{ fontSize: 14, color: 'red', fontWeight: 400 }}>
                          {translate('comexApp.quotation.amountMustBeGreaterThanZero')}
                        </Label>
                      )}
                      {(isNew || hasRecalculated) && hasCalculated && !calculationLoading && amountV > convertLimitAmount && (
                        <Label className="p-0" style={{ fontSize: 14, color: 'red', fontWeight: 400 }}>
                          {translate('comexApp.quotation.amountLimit')} {convertLimitAmount?.toLocaleString()}
                        </Label>
                      )}
                      {isSaveButtonClicked === true && filterCurrency?.buyFrom?.active === false && (
                        <Label className="p-0" style={{ fontSize: 14, color: 'red', fontWeight: 400 }}>
                          {errMsgCurrency}
                        </Label>
                      )}
                    </div>
                  </div>
                  <div className="form-group row" style={{ alignItems: 'center' }}>
                    <div className="col-sm-3">
                      <Label>{translate('comexApp.quotation.itemName')}</Label>
                      <Label style={{ color: 'red' }}>*</Label>
                    </div>
                    <div className="col-sm-9 box-space">
                      <ValidatedField
                        id="item_name_option"
                        name="item_name"
                        data-cy="item_name"
                        type="select"
                        onChange={handlerItem}
                        value={itemName ?? ''}
                        required
                        validate={
                          isNew && {
                            required: { value: true, message: translate('entity.validation.required') },
                          }
                        }
                      >
                        <option key="0" />
                        {filteredCommodities?.map(item => (
                          <option value={item.name} key={item.id}>
                            {item.name}
                          </option>
                        ))}
                      </ValidatedField>
                    </div>
                  </div>
                  {renderCalculationStatus()}
                  {(!isNew || (hasCalculated && !calculationLoading)) && (
                    <>
                      <div className="form-group row" style={{ alignItems: 'center' }}>
                        <div className="col-sm-3">
                          <Label>{translate('comexApp.quotation.description')}</Label>
                        </div>
                        <div className="col-sm-9 box-space">
                          <ValidatedField
                            id="description"
                            name="description"
                            data-cy="description"
                            type="textarea"
                            value={Storage.session.get('locale') === 'en' ? itemDescription ?? '' : itemDescriptionInArabic ?? ''}
                            disabled={true}
                          />
                        </div>
                      </div>
                      <div className="form-group row" style={{ alignItems: 'center' }}>
                        <div className="col-sm-3">
                          <Label>{translate('comexApp.quotation.price')}</Label>
                        </div>
                        <div
                          className="row col-sm-9"
                          style={
                            Storage.session.get('locale') === 'en'
                              ? { paddingRight: '0px', paddingLeft: '24px' }
                              : { paddingRight: '24px', paddingLeft: '0px' }
                          }
                        >
                          <div className="col-5 col-sm-3 px-0 box-space">
                            <ValidatedField
                              id="currency_name_option"
                              name="currency_name"
                              data-cy="currency_name"
                              type="text"
                              value={currencyName ?? ''}
                              disabled={true}
                            />
                          </div>
                          <div className="col-7 col-sm-9 px-0 box-space">
                            <ValidatedField
                              id="price"
                              name="price"
                              data-cy="price"
                              value={(itemPrice ?? 0).toLocaleString()}
                              disabled={true}
                              style={{
                                textAlign: Storage.session.get('locale') === 'en' ? 'left' : 'right',
                              }}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="form-group row" style={{ alignItems: 'center' }}>
                        <div className="col-sm-3">
                          <Label>{translate('comexApp.quotation.quantity')}</Label>
                        </div>
                        <div
                          className="row col-sm-9"
                          style={
                            Storage.session.get('locale') === 'en'
                              ? { paddingRight: '0px', paddingLeft: '24px' }
                              : { paddingRight: '24px', paddingLeft: '0px' }
                          }
                        >
                          <div className="col-5 col-sm-3 px-0 box-space">
                            <ValidatedField
                              id="quantity_unit"
                              name="quantity_unit"
                              data-cy="quantity_unit"
                              type="text"
                              value={itemQuantityUnit || 'Ton'}
                              disabled={true}
                            />
                          </div>
                          <div className="col-7 col-sm-9 px-0 box-space">
                            <ValidatedField
                              id="quantity"
                              name="quantity"
                              data-cy="quantity"
                              value={(itemQuantity ?? 0).toLocaleString()}
                              disabled={true}
                              style={{
                                textAlign: Storage.session.get('locale') === 'en' ? 'left' : 'right',
                              }}
                            />
                          </div>
                        </div>
                      </div>
                      <p
                        hidden={validationForCommodity === true}
                        className="mt-1 mb-0"
                        style={{
                          color: 'red',
                          fontWeight: 400,
                        }}
                      >
                        {translate('comexApp.quotation.validationForCommodity')}
                      </p>

                      <div
                        className="form-group row"
                        style={{ alignItems: 'center' }}
                        hidden={
                          isNew ? bankEntity?.displayTransactionFee === false : quotationEntity?.bank?.displayTransactionFee === false
                        }
                      >
                        <div className="col-sm-3">
                          <Label>{translate('comexApp.quotation.transactionFee')}</Label>
                        </div>
                        <div
                          className="row col-sm-9"
                          style={
                            Storage.session.get('locale') === 'en'
                              ? { paddingRight: '0px', paddingLeft: '24px' }
                              : { paddingRight: '24px', paddingLeft: '0px' }
                          }
                        >
                          <div className="col-5 col-sm-3 px-0 box-space">
                            <ValidatedField
                              id="currency_name_option"
                              name="currency_name"
                              data-cy="currency_name"
                              type="text"
                              value={displayCurrencyName || ''}
                              disabled={true}
                            />
                          </div>
                          <div className="col-7 col-sm-9 px-0 box-space">
                            <ValidatedField
                              id="fee"
                              name="fee"
                              data-cy="fee"
                              value={(displayTransactionFee ?? transactionFee ?? 0).toLocaleString()}
                              disabled={true}
                              style={{
                                textAlign: Storage.session.get('locale') === 'en' ? 'left' : 'right',
                              }}
                            />
                          </div>
                        </div>
                      </div>

                      {shouldDisplayFeeInQuotationCurrency && (
                        <div className="form-group row" style={{ alignItems: 'center' }}>
                          <div className="col-sm-3">
                            <Label>{translate('comexApp.quotation.transactionFeeInQuotationCurrency')}</Label>
                          </div>
                          <div
                            className="row col-sm-9"
                            style={
                              Storage.session.get('locale') === 'en'
                                ? { paddingRight: '0px', paddingLeft: '24px' }
                                : { paddingRight: '24px', paddingLeft: '0px' }
                            }
                          >
                            <div className="col-5 col-sm-3 px-0 box-space">
                              <ValidatedField
                                id="quotation_currency_name_option"
                                name="quotation_currency_name"
                                data-cy="quotation_currency_name"
                                type="text"
                                value={currencyName || ''}
                                disabled={true}
                              />
                            </div>
                            <div className="col-7 col-sm-9 px-0 box-space">
                              <ValidatedField
                                id="quotation_fee"
                                name="quotation_fee"
                                data-cy="quotation_fee"
                                value={(displayTransactionFeeInQuotationCurrency ?? transactionFeeInQuotationCurrency ?? 0).toLocaleString()}
                                disabled={true}
                                style={{
                                  textAlign: Storage.session.get('locale') === 'en' ? 'left' : 'right',
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      )}
                    </>
                  )}
                  <div className="form-group row" style={{ alignItems: 'center' }} hidden>
                    <div className="col-sm-3">
                      <Label>{translate('comexApp.quotation.totalAmount')}</Label>
                    </div>
                    <div
                      className="row col-sm-9"
                      style={
                        Storage.session.get('locale') === 'en'
                          ? { paddingRight: '0px', paddingLeft: '24px' }
                          : { paddingRight: '24px', paddingLeft: '0px' }
                      }
                    >
                      <div className="col-5 col-sm-3 px-0 box-space">
                        <ValidatedField
                          id="currency_name_option"
                          name="currency_name"
                          data-cy="currency_name"
                          type="text"
                          value={currencyName || ''}
                          disabled={true}
                        />
                      </div>
                      <div className="col-7 col-sm-9 px-0 box-space">
                        <ValidatedField
                          id="totalAmount"
                          name="totalAmount"
                          data-cy="totalAmount"
                          value={(itemTotalAmount ?? 0).toLocaleString()}
                          disabled={true}
                          style={{
                            textAlign: Storage.session.get('locale') === 'en' ? 'left' : 'right',
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  &nbsp;
                  <Divider />
                  &nbsp;
                  <ThemeProvider theme={responsiveFont}>
                    <Typography variant="h6" component="div">
                      <strong>{translate('comexApp.quotation.requestedBy')}</strong>
                    </Typography>
                  </ThemeProvider>
                  &nbsp;
                  <div className="form-group row" style={{ alignItems: 'center' }}>
                    <div className="col-sm-3">
                      <Label>{translate('comexApp.quotation.nationalId')}</Label>
                      <Label style={{ color: 'red' }}>*</Label>
                    </div>
                    <div className="col-sm-9">
                      <ValidatedField
                        id="national_id"
                        name="national_id"
                        data-cy="national_id"
                        type="text"
                        size={10}
                        value={trimmedIc ? trimmedIc : ''}
                        onChange={e => {
                          setCusIc(e.target.value.trim());
                        }}
                        onKeyPress={e => {
                          if (e.key === 'Enter') {
                            e.preventDefault();
                            customerSearch();
                          }
                        }}
                        required
                        validate={{
                          required: { value: true, message: translate('entity.validation.required') },
                        }}
                      />
                    </div>
                  </div>
                  <div hidden={errorSearchNationalId} className="form-group row mb-2" style={{ alignItems: 'center' }}>
                    <div className="col-sm-3"></div>
                    <div className="col-sm-9">
                      <Label style={{ fontSize: 14, color: 'red', fontWeight: 400 }}>
                        <Translate contentKey={'global.messages.validate.searchNationalId.required'} />
                      </Label>
                    </div>
                  </div>
                  <div className="quotationBtn col-sm-12 pb-3">
                    <Button color="primary" id="search-customer" className="searchBtn" onClick={customerSearch}>
                      <Row className={'px-1'}>
                        <Col className={'px-1'}>
                          <Translate contentKey={'comexApp.quotation.searchCustomerButton'} />
                        </Col>
                        <Col className={'px-1'}>
                          <FontAwesomeIcon icon={faSearch} />
                        </Col>
                      </Row>
                    </Button>
                  </div>
                  <div hidden={hideCustomer}>
                    <div className="form-group row" style={{ alignItems: 'center' }}>
                      <div className="col-sm-3">
                        <Label>{translate('comexApp.quotation.customer')}</Label>
                        <Label style={{ color: 'red' }}>*</Label>
                      </div>
                      <div className="col-sm-9" style={{ marginBottom: '10px' }}>
                        <ValidatedField
                          id="cust_name"
                          name="cust_name"
                          data-cy="cust_name"
                          disabled={isNew && disable}
                          type="text"
                          value={cusName ?? ''}
                          style={{ marginBottom: '-20px' }}
                          onChange={event => {
                            const cusNameChange = event.target.value.replace(/[^a-zA-Z0-9\s]/g, '').replace(/^\s+/, '');
                            setCusName(cusNameChange);
                          }}
                          required
                          validate={
                            cusName === ''
                              ? {
                                  required: { value: true, message: translate('entity.validation.required') },
                                }
                              : {
                                  required: false,
                                }
                          }
                        />
                        <div hidden={!limitCusName}>
                          <small style={{ fontStyle: 'italic' }}>{translate('entity.validation.customerNameValidate')}</small>
                        </div>
                        <div hidden={limitCusName}>
                          <small style={{ fontSize: 14, color: 'red', fontWeight: 400, paddingLeft: '0px', paddingRight: '8px' }}>
                            <Translate contentKey={'global.messages.validate.customerName.maxlength'} />
                          </small>
                        </div>

                        <ValidatedField
                          id="cust_name_ar"
                          name="cust_name_ar"
                          data-cy="cust_name_ar"
                          disabled={isNew && disable}
                          type="text"
                          value={cusNameAr ?? ''}
                          dir="rtl"
                          style={{ marginTop: '10px', marginBottom: '-20px', textAlign: 'right' }}
                          onChange={handleArabicNameChange}
                          required={quotationType === 'local'}
                          validate={
                            quotationType === 'local'
                              ? {
                                  required: {
                                    value: true,
                                    message: translate('entity.validation.required'),
                                  },
                                }
                              : {}
                          }
                        />
                        <div>
                          <small style={{ fontStyle: 'italic' }}>
                            {translate('entity.validation.customerNameValidateAr', {
                              requirement:
                                Storage.session.get('locale') === 'ar-ly'
                                  ? quotationType === 'local'
                                    ? 'إلزامي'
                                    : 'اختياري'
                                  : quotationType === 'local'
                                  ? 'Mandatory'
                                  : 'Optional',
                            })}
                          </small>
                        </div>
                        <div hidden={!(showArabicNameError && !isArabicNameValid)}>
                          <small style={{ fontSize: 14, color: 'red', fontWeight: 400, paddingLeft: '0px', paddingRight: '8px' }}>
                            <Translate contentKey={'global.messages.validate.customerName.minlength'} />
                          </small>
                        </div>
                      </div>
                    </div>

                    <div className="form-group row" style={{ alignItems: 'center' }}>
                      <div className="col-sm-3">
                        <Label>{translate('comexApp.quotation.nationality')}</Label>
                        <Label style={{ color: 'red' }}>*</Label>
                      </div>
                      <div className="col-sm-9">
                        <ValidatedField
                          id="cust_nationality_option"
                          name="cust_nationality"
                          data-cy="cust_nationality"
                          type="select"
                          disabled={isNew && disable}
                          onChange={handlerNationality}
                          value={
                            Storage.session.get('locale') === 'en'
                              ? cusNationality ?? ''
                              : countryList.find(c => c.Desc_en === cusNationality)['Desc_ar'] ?? ''
                          }
                          style={{
                            textAlign: Storage.session.get('locale') === 'en' ? 'left' : 'right',
                          }}
                          required
                          validate={
                            isNew && {
                              required: { value: true, message: translate('entity.validation.required') },
                            }
                          }
                        >
                          {Storage.session.get('locale') === 'en'
                            ? countryList
                              ? Object.keys(countryList).map((key, index) => (
                                  <option key={index} value={countryList[key]['Desc_en']}>
                                    {countryList[index]['Desc_en']}
                                  </option>
                                ))
                              : null
                            : countryList
                            ? Object.keys(countryList).map((key, index) => (
                                <option key={index} value={countryList[key]['Desc_ar']}>
                                  {countryList[index]['Desc_ar']}
                                </option>
                              ))
                            : null}
                        </ValidatedField>
                      </div>
                    </div>

                    <div className="form-group row mb-2" style={{ alignItems: 'center' }}>
                      <div className="col-sm-3">
                        <Label>{translate('comexApp.quotation.phoneNo')}</Label>
                        {(isNew ? (bankEntity?.enableCustomerLogin !== false) : (quotationEntity?.bank?.enableCustomerLogin !== false)) && (
                          <Label style={{ color: 'red' }}>*</Label>
                        )}
                      </div>
                      <div className="col-sm-9" style={{ marginBottom: '-10px' }}>
                        <PhoneInput
                          country={countryCode}
                          value={phone ?? ''}
                          onChange={setPhone}
                          inputStyle={{
                            marginBottom: '2%',
                            textAlign: Storage.session.get('locale') === 'en' ? 'left' : 'right',
                            direction: 'ltr',
                          }}
                          disabled={isNew && disable}
                          disableDropdown={true}
                        />
                      </div>

                      {errorPhoneExist !== '' && (
                        <div className="form-group row mb-2" style={{ alignItems: 'center' }}>
                          <div className="col-sm-3"></div>
                          <div className="col-sm-9" style={{ marginBottom: '-10px' }}>
                            <Label style={{ color: '#DC3545', fontSize: 14, fontWeight: 400, paddingLeft: 0, marginTop: '5px' }}>
                              {errorPhoneExist}
                            </Label>
                          </div>
                        </div>
                      )}

                      {(isNew ? (bankEntity?.enableCustomerLogin !== false) : (quotationEntity?.bank?.enableCustomerLogin !== false)) && (
                        <div hidden={errorPhone} className="form-group row mb-2" style={{ alignItems: 'center' }}>
                          <div className="col-sm-3"></div>
                          <div className="col-sm-9">
                            <small style={{ fontSize: 14, color: 'red', fontWeight: 400, paddingLeft: '5px', paddingRight: '8px' }}>
                              <Translate contentKey={'global.messages.validate.phone.required'} />
                            </small>
                          </div>
                        </div>
                      )}
                    </div>

                    <div className="form-group row" style={{ alignItems: 'center' }}>
                      <div className="col-sm-3">
                        <Label>{translate('comexApp.quotation.email')}</Label>
                      </div>
                      <div className="col-sm-9">
                        <ValidatedField
                          id="email"
                          name="email"
                          type="email"
                          placeholder={translate('comexApp.quotation.optionalField')}
                          disabled={isNew && disable}
                          style={{
                            textAlign: Storage.session.get('locale') === 'en' ? 'left' : 'right',
                          }}
                          onChange={event => checkExistingEmail(event.target.value)}
                          value={cusEmail ?? ''}
                          // required
                          validate={{
                            // required: {
                            //   value: true,
                            //   message: translate('global.messages.validate.email.required'),
                            // },
                            minLength: {
                              value: 5,
                              message: translate('global.messages.validate.email.minlength'),
                            },
                            maxLength: {
                              value: 254,
                              message: translate('global.messages.validate.email.maxlength'),
                            },
                            pattern: {
                              value:
                                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                              message: translate('global.messages.validate.email.invalid'),
                            },
                          }}
                        />
                      </div>
                      <div hidden={requiredEmail} className="form-group row mb-2" style={{ alignItems: 'center' }}>
                        <div className="col-sm-3"></div>
                        <div className="col-sm-9">
                          <small style={{ fontSize: 14, color: 'red', fontWeight: 400, paddingLeft: '5px', paddingRight: '8px' }}>
                            <Translate contentKey={'global.messages.validate.email.required'} />
                          </small>
                        </div>
                      </div>
                      <div hidden={errorEmail} className="form-group row mb-2" style={{ alignItems: 'center' }}>
                        <div className="col-sm-3"></div>
                        <div className="col-sm-9">
                          <small style={{ fontSize: 14, color: 'red', fontWeight: 400, paddingLeft: '5px', paddingRight: '8px' }}>
                            <Translate contentKey={'register.messages.error.emailexists'} />
                          </small>
                        </div>
                      </div>
                    </div>
                    {operationTime === false ? (
                      <div className="col-sm-12" style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <span style={{ color: 'red' }}>
                          <Translate
                            contentKey="home.operationTime"
                            interpolate={{ startTime: moment(localStart).format('hh:mm A'), endTime: moment(localEnd).format('hh:mm A') }}
                          ></Translate>
                        </span>
                      </div>
                    ) : (
                      <></>
                    )}

                    {/* {quotationType === 'local' && (*/}
                    {/*  <>*/}
                    {/*    { /* IBAN *!/*/}
                    {/*    <div className="form-group row" style={{alignItems: 'center'}}>*/}
                    {/*      <div className="col-sm-3">*/}
                    {/*        <Label>{translate('comexApp.quotation.ibanNumber')}</Label>*/}
                    {/*      </div>*/}
                    {/*      <div className="col-sm-9">*/}
                    {/*        <ValidatedField*/}
                    {/*          id="iban"*/}
                    {/*          name="iban"*/}
                    {/*          type="text"*/}
                    {/*          placeholder="Eg. 123123123123"*/}
                    {/*          style={{*/}
                    {/*            textAlign: Storage.session.get('locale') === 'en' ? 'left' : 'right',*/}
                    {/*          }}*/}
                    {/*          onChange={handleIBANInputChange}*/}
                    {/*          value={ibanValue}*/}
                    {/*          min={1}*/}
                    {/*        />*/}
                    {/*      </div>*/}
                    {/*    </div>*/}

                    {/*    {ibanTouched && ibanValue.length > 0 && ibanValue.length !== 30 && (*/}
                    {/*      <div className="form-group row mb-2" style={{alignItems: 'center'}}>*/}
                    {/*        <div className="col-sm-3"></div>*/}
                    {/*        <div className="col-sm-9">*/}
                    {/*          <Label style={{color: "#DC3545", fontSize: 14, fontWeight: 400}}>*/}
                    {/*            {translate('comexApp.quotation.ibanNumberMsg')}*/}
                    {/*          </Label>*/}
                    {/*        </div>*/}
                    {/*      </div>*/}
                    {/*    )}*/}

                    {/*    { /* BANK NAME *!/*/}
                    {/*    <div className="form-group row" style={{alignItems: 'center'}}>*/}
                    {/*      <div className="col-sm-3">*/}
                    {/*        <Label>{translate('comexApp.quotation.bankName')}</Label>*/}
                    {/*      </div>*/}
                    {/*      <div className="col-sm-9">*/}
                    {/*        <ValidatedField*/}
                    {/*          id="bankName"*/}
                    {/*          name="bankName"*/}
                    {/*          type="text"*/}
                    {/*          placeholder="Enter bank name"*/}
                    {/*          value={bankEntity?.name || ''}*/}
                    {/*          disabled*/}
                    {/*        />*/}
                    {/*      </div>*/}
                    {/*    </div>*/}

                    {/*    { /* BRANCH NAME *!/*/}
                    {/*    <div className="form-group row" style={{alignItems: 'center'}}>*/}
                    {/*      <div className="col-sm-3">*/}
                    {/*        <Label>{translate('comexApp.quotation.branchName')}</Label>*/}
                    {/*      </div>*/}
                    {/*      <div className="col-sm-9">*/}
                    {/*        <ValidatedField*/}
                    {/*          id="branchName"*/}
                    {/*          name="branchName"*/}
                    {/*          type="text"*/}
                    {/*          placeholder="Enter branch name"*/}
                    {/*          value={branchEntity?.name || ''}*/}
                    {/*          disabled*/}
                    {/*        />*/}

                    {/*      </div>*/}
                    {/*    </div>*/}
                    {/*  </> */}
                    {/* )} */}

                    {quotationType === 'local' && renderValidUntilField()}

                    <div className="quotationBtn col-sm-12">
                      <Button
                        color="primary"
                        id="save-entity"
                        data-cy="entityCreateSaveButton"
                        type="submit"
                        disabled={updating || isSaveButtonClicked2 || validationForCommodity === false || preventMultipleClick || amountV <= 0 || !hasCalculated || calculationLoading || amountV !== debouncedAmountV || isCalcStale}
                        onClick={() => {
                          validateCurrency();
                        }}
                      >
                        <Translate contentKey={isNew ? 'comexApp.quotation.createBtnLabel' : 'comexApp.quotation.updateBtnLabel'}>
                          Create
                        </Translate>
                      </Button>
                    </div>
                  </div>
                </ValidatedForm>
              </>
            )}
          </Col>
        </Row>

        <Col md="8" lg="6" style={{ marginTop: '28px', marginBottom: '32px' }}>
          <Button onClick={handleBack}>
            <FontAwesomeIcon icon="arrow-left" />
            &nbsp;
            <Translate contentKey="entity.action.back">Back</Translate>
          </Button>
        </Col>
      </Row>
    </>
  );
};
//

export default QuotationUpdate;
